import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCashier = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.412 19.05H6.189C4.223 19.05 3 17.663 3 15.7V8.3c0-1.963 1.223-3.35 3.188-3.35h11.624C19.772 4.95 21 6.337 21 8.3v2M6.213 8.451h1.403M20.118 18.258a2.608 2.608 0 0 1-4.333-1.956"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.668 14.347a2.608 2.608 0 0 1 4.333 1.956"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.71 12.001a2.287 2.287 0 1 1 4.576 0 2.287 2.287 0 0 1-4.575 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCashier);
export default ForwardRef;
